import { useState } from 'react';
import { NetflixRow, NetflixCard } from './NetflixRow';
import { CardDetailModal } from './CardDetailModal';

export const AwardsRow = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const awards = [
    {
      title: "NYDFS Perfect Compliance Achievement",
      subtitle: "Discover Financial • 2020",
      description: "Achieved zero findings in NYDFS cybersecurity examination for new banking entity approval, demonstrating exceptional cybersecurity governance maturity. This perfect compliance record enabled business expansion into regulated banking markets while establishing a benchmark for cybersecurity excellence in financial services industry.",
      match: "Regulatory Excellence",
      tags: ["NYDFS", "Zero Findings", "Banking Compliance"],
      imageSrc: "https://images.unsplash.com/photo-1569705460033-cfaa4bf9f822?w=800"
    },
    {
      title: "FedRAMP Timeline Innovation Recognition",
      subtitle: "Google Cloud • 2024",
      description: "Recognition for achieving 20% reduction in FedRAMP authorization timelines through OSCAL-based automation innovation. This breakthrough achievement accelerated government cloud adoption, reduced compliance costs, and established new industry standards for automated compliance evidence collection and validation.",
      match: "Innovation Leader",
      tags: ["FedRAMP", "Innovation", "OSCAL Automation"],
      imageSrc: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800"
    },
    {
      title: "Industry Leadership Excellence",
      subtitle: "Cloud Security Alliance • 2023-2025",
      description: "Recognition for exceptional leadership as Global Chair of Cloud Controls Matrix and AI Controls Framework development. Leading international working groups, coordinating global expert consensus, and establishing foundational frameworks that define security standards used by thousands of organizations worldwide.",
      match: "Global Leadership",
      tags: ["CSA Leadership", "Global Standards", "Framework Development"],
      imageSrc: "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800"
    },
    {
      title: "Cyber Insurance Optimization Achievement",
      subtitle: "Discover Financial • 2021",
      description: "Successfully negotiated $125M cyber insurance expansion while achieving $50K premium reduction and adding nation-state threat coverage. This achievement demonstrated exceptional risk quantification skills and strategic negotiation capabilities, resulting in enhanced risk coverage with optimized costs.",
      match: "Risk Management",
      tags: ["Cyber Insurance", "Risk Management", "Cost Optimization"],
      imageSrc: "https://images.unsplash.com/photo-1560438718-eb61ede255eb?w=800"
    }
  ];

  const handleCardClick = (item, type) => {
    setSelectedCard({...item, type});
    setModalOpen(true);
  };

  return (
    <>
      <NetflixRow title="Recognition & Achievements" id="awards">
        {awards.map((award, index) => (
          <NetflixCard
            key={index}
            title={award.title}
            subtitle={award.subtitle}
            description={award.description}
            match={award.match}
            tags={award.tags}
            imageSrc={award.imageSrc}
            onClick={() => handleCardClick(award, 'award')}
          />
        ))}
      </NetflixRow>
      
      <CardDetailModal 
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        card={selectedCard}
        type="award"
      />
    </>
  );
};